import store from '../store/index.js'
import router from "../router";
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { ImagePreview } from 'vant';

var arrlist={}
var roots=''
let ToastBox ="";
function param(data) {
    var str = "";
    for (var k in data) {
    var value = data[k] !== undefined ? data[k] : "";
    str += "&" + k + "=" + encodeURIComponent(value);
    }
    return str;
}
//时间格式化1
Date.prototype.format = function(format) {
	var o = {
		"M+": this.getMonth() + 1, //month
		"d+": this.getDate(), //day
		"h+": this.getHours(), //hour
		"m+": this.getMinutes(), //minute
		"s+": this.getSeconds(), //second
		"q+": Math.floor((this.getMonth() + 3) / 3), //quarter
		"S": this.getMilliseconds() //millisecond
	}
	if(/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for(var k in o) {
		if(new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
		}
	}
	if(format == 0) {
		format = 0;
	}
	if(format.indexOf('NaN')!=-1){
		return '---'
	}else{
		return format;
	}
	
}



const common = {
    install: function (Vue) {
        Vue.prototype.commonConfig = { //公共配置文件
            // errorImg: "this.src='./images/unloginPhoto.png'", //会员中心头像错误图
            errorImg: "this.src='../../images/unloginPhoto.png'", //会员中心头像错误图
        },
        Vue.prototype.sharePage =(app,url,tit)=> { //分享方法
            
        },
        Vue.prototype.gototop=false,
        Vue.prototype.alt=function(a,b){//弹出提示框
            Dialog.alert({
                title:b?b:null,
                message: a,
              }).then(() => {
                // on close
              });
        },
        Vue.prototype.back=function(){//返回
            var that=this;
            window.history.go(-1);
        },
        Vue.prototype.goto=function(id,dt,dd){
            var that=this;
            router.push(id);
        },
        Vue.prototype.errorImg="this.src='"+ roots +"/static/404.png'",
        Vue.prototype.errorImg_f="this.src='"+ roots +"/static/fno.png'",
        Vue.prototype.Img404=roots+"/static/404.png",
        Vue.prototype.Img404_f=roots+"/static/fno.png",
        Vue.prototype.gethash= (name) => {//获取hash参数
            var parameter = "?"+window.location.hash.slice(2).split("?")[1];
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = parameter.substr(1).match(reg);
            if (r != null) {return decodeURI(r[2]);
            } else{
            return null;
            }
        },
        Vue.prototype.$img=function(a,b){//查看图片
            let url=null
            let bb=0,ind=false;
            if(b != undefined){
                bb=b;
                ind=true;
            }
            if(typeof a == 'object'){
                url=a;
            }else if(event.target.src){
                url=[event.target.src]
            }
            console.log(a,b)
            if(url){
                ImagePreview({
                  images: url,
                  closeable: true,
                  startPosition:bb,
                  showIndex:ind
                });
              }
        },
        Vue.prototype.setSize=function(){
            
        /* 设计图文档宽度 */
        var docWidth = 750;
        var doc = window.document,
            docEl = doc.documentElement,
            resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

        var recalc = (function refreshRem () {
            var clientWidth = docEl.getBoundingClientRect().width;

            /* 8.55：小于320px不再缩小，11.2：大于420px不再放大 */
            docEl.style.fontSize = Math.max(Math.min(20 * (clientWidth / docWidth), 20), 8.55) * 5 + 'px';
            return refreshRem;
        })();

        /* 添加倍屏标识，安卓倍屏为1 */
        docEl.setAttribute('data-dpr', window.navigator.appVersion.match(/iphone/gi) ? window.devicePixelRatio : 1);

        if (/iP(hone|od|ad)/.test(window.navigator.userAgent)) {
            /* 添加IOS标识 */
            doc.documentElement.classList.add('ios');
            /* IOS8以上给html添加hairline样式，以便特殊处理 */
            if (parseInt(window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10) >= 8)
                doc.documentElement.classList.add('hairline');
        }

        if (!doc.addEventListener) return;
        window.addEventListener(resizeEvt, recalc, false);
        doc.addEventListener('DOMContentLoaded', recalc, false);


            //微信浏览器禁用字体缩放功能
            if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
                handleFontSize();
            } else {
                if (document.addEventListener) {
                    document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
                } else if (document.attachEvent) {
                    document.attachEvent("WeixinJSBridgeReady", handleFontSize);
                    document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
                }
            }
            function handleFontSize() {
                // 设置网页字体为默认大小
                WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0});
                // 重写设置网页字体大小的事件
                WeixinJSBridge.on('menu:setfont', function () {
                    WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0});
                });
            }
            //end
        },
        Vue.prototype.getCookie=function(name) {
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg))
                return unescape(arr[2]);
            else
                return "null";
        },
        Vue.prototype.setCookie=function(name,value,Days) 
        { 
            var exp = new Date(); 
            if(Days>0){
            exp.setTime(exp.getTime() + Days*24*60*60*1000); 
            }
            else{
                    exp.setTime(-1); 
            }
            document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()+";path=/"; 
        },
        Vue.prototype.delCookie=function(name)
        {
            var exp = new Date();
            exp.setTime(exp.getTime() - 1);
            var cval=this.getCookie(name);
            if(cval!=null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
        },
        Vue.prototype.clearCookie=function() {
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            if (keys) {
                for (var i = keys.length; i--;) {
                    document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + "; path=/"
                }
            }
        }
        }
}
export default common;



// WEBPACK FOOTER //
// ./src/components/common.js